import { render, staticRenderFns } from "./BonusEdit.vue?vue&type=template&id=11f945f9&scoped=true"
import script from "./BonusEdit.vue?vue&type=script&lang=js"
export * from "./BonusEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f945f9",
  null
  
)

export default component.exports